<ng-container *ngIf="!isLoading.value && (dataValue | async)?.delivery_address as deliveryAddress; else loadingTpl">
  <div *ngFor="let item of deliveryAddress">
    <div class="mb-7">
      <app-card-verification-form
        (afterActionVerification)="afterActionVerification($event)"
        (cardNoteChanged)="noteChanged($event, getIdShippingAddress(item))"
        [bodyData]="generateBodyData(item)"
        [cardNoteValue]="noteValue(getIdShippingAddress(item))"
        [idShippingAddress]="getIdShippingAddress(item)"
        [isLoading]="isLoading"
        [isNotHaveRevision]="detailRegistrationService.checkNotHaveRevision(item, item.status_change_enum)"
        [isViewOnly]="isViewOnly"
        [sessionKey]="revisionType"
        [withBadgeCheck]="ShowBadge"
        [statusChangeEnum]="item.status_change_enum"
        [status]="item?.status_verified_enum"
        [title]="item.current_data.label"
        [typeSection]="EnumCardVerificationSection.DELIVERY_ADDRESS"
        [type]="EnumCardVerificationForm.MODAL_MAP"
      />
    </div>
  </div>
</ng-container>

<ng-template #loadingTpl>
  <div class="mb-7">
    <app-card-verification-form
      [isLoading]="isLoading"
      [isViewOnly]="isViewOnly"
      [typeSection]="EnumCardVerificationSection.DELIVERY_ADDRESS"
      [type]="EnumCardVerificationForm.MODAL_MAP"
    />
  </div>
</ng-template>
